import { DaypilotCoreEvent, SupportedObjectTypes } from './daypilot-core-event'
import { ActivityActor } from "./activityActor";
import { BusEnum } from "../common/enums";
import { StateMachineEventEnum } from "./stateMachineEvent";

export interface IActivityActorEvent extends DaypilotCoreEvent {
  activityActor?: ActivityActor;
}

export class ActivityActorEvent extends DaypilotCoreEvent implements IActivityActorEvent {
  public activityActor?: ActivityActor;
  public planned: boolean;

  public get IsTransfer() {
    return this.activityActor.actor.type === BusEnum.Transfer;
  }

  public get IsFlight() {
    return this.activityActor.actor.type === BusEnum.Air;
  }


  public constructor(id: string, text: string, start: Date, end: Date, resource: string, activityActor: ActivityActor) {
    super(id, text, start, end, resource, SupportedObjectTypes.ActivityActorEvent);

    this.activityActor = activityActor;

    this.setPlannedInternal();
    this.resource = this.IsTransfer && !this.planned ? "transfers" : resource;
  }

  public setPlanned(value: boolean) {
    this.planned = value;
  }

  private setPlannedInternal() {
    this.setTransferPlanned();
    this.setFlightPlanned();
    this.setOtherPlanned();
  }

  private setOtherPlanned() {
    let currentState = this.activityActor.state;
    if (!this.IsFlight &&
      !this.IsTransfer &&
      currentState !== StateMachineEventEnum.Cancel &&
      currentState !== StateMachineEventEnum.UnAssign &&
      currentState !== StateMachineEventEnum.Create) {
      this.planned = true;
    }
  }

  private setFlightPlanned() {
    let currentState = this.activityActor.state;
    if (this.IsFlight &&
      currentState !== StateMachineEventEnum.Cancel &&
      currentState !== StateMachineEventEnum.UnAssign
    ) {
      this.planned = true;
    }
  }

  private setTransferPlanned() {
    let currentState = this.activityActor.state;
    if (this.IsTransfer &&
      currentState !== StateMachineEventEnum.Cancel &&
      currentState !== StateMachineEventEnum.UnAssign &&
      currentState !== StateMachineEventEnum.Create
      ) {
      this.planned = true;
    }
  }
}
